import React from 'react';

type Props = {
    actionId            : string
    errorMessage        : string
    hasAccess           : boolean
    fadeTime            : number
    close               : callback
}

export default function ActionRunFailed(props:Props) {

    const openAction = () => {
        if (!props.hasAccess) {
            return
        }

        gd.goTo('action/{0}'.f(props.actionId))
        props.close()
    }

    const style : style = {
        transition: "opacity " + props.fadeTime + "s"
    }

    return (
        <div className  = "ui5-pale-bg notification h-100-percent warning"
             style      = {style}
        >
            <div className  = "flex-row-left-center"
                 onClick    = {openAction}
            >
                <div className="left-indicator"/>
                <div className="i5-emergency-solid ui5-color-yellow m-l-3"/>
                <div className="message ui5-txt-not-important-small m-l-10">
                    {props.errorMessage}
                </div>
            </div>

            <div className  = "close i5-delete"
                 onClick    = {props.close}
            />
        </div>
    )

}
